(function () {
  'use strict';

  /* =========================================================
     OUTILS TEXTE
     ========================================================= */

  function clean(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+/g, ' ')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/[ \t]+\n/g, '\n')
      .trim();
  }


  function textWithBreaks(node) {
    if (!node) return '';

    var clone = node.cloneNode(true);

    clone.querySelectorAll('br').forEach(function (br) {
      br.replaceWith('\n');
    });

    clone.querySelectorAll('li').forEach(function (li) {
      li.insertAdjacentText('beforebegin', '\n');
      li.insertAdjacentText('afterend', '\n');
    });

    clone
      .querySelectorAll('p, div, blockquote')
      .forEach(function (el) {
        el.insertAdjacentText('afterend', '\n');
      });

    return clean(clone.textContent || '');
  }


  function sentenceSplit(text) {
    var found =
      clean(text).match(/[^.!?]+(?:[.!?]+|$)/g) || [];

    return found
      .map(clean)
      .filter(function (item) {
        return item.length > 2;
      });
  }


  /* =========================================================
     DÉCOUPAGE BÉNÉFICES / IDÉAL POUR VOUS
     ========================================================= */

  function splitChunk(raw, mode) {
    var value = (raw || '')
      .replace(/\r/g, '\n')
      .trim();

    if (!value) return [];


    var lines = value
      .split(/\n+/)
      .map(clean)
      .filter(Boolean);


    /*
      Pour "Idéal pour vous" :
      si une ligne commence en minuscule,
      on considère que c'est la suite de la précédente.

      Exemple :
      Vous souhaitez commencer
      votre routine anti-vergetures...

      => une seule carte
    */
    if (mode === 'ideal' && lines.length > 1) {
      var merged = [];

      lines.forEach(function (line) {
        if (!merged.length) {
          merged.push(line);
          return;
        }

        var beginsLowercase =
          /^[a-zà-ÿ]/.test(line);

        if (beginsLowercase) {
          var previous =
            merged[merged.length - 1]
              .replace(/[.!?]+$/, '')
              .trim();

          merged[merged.length - 1] =
            clean(previous + ' ' + line);
        } else {
          merged.push(line);
        }
      });

      lines = merged;
    }


    if (lines.length > 1) {
      return lines.reduce(
        function (all, line) {
          return all.concat(
            splitChunk(line, mode)
          );
        },
        []
      );
    }


    var text = clean(value);


    /* Puces / coches */

    if (/[✓✔•●▪]/.test(text)) {
      var marked = text
        .split(/\s*[✓✔•●▪]+\s*/)
        .map(clean)
        .filter(Boolean);

      if (marked.length > 1) {
        return marked;
      }

      if (marked.length === 1) {
        text = marked[0];
      }
    }


    /* Vraies phrases */

    var sentences =
      sentenceSplit(text);

    if (sentences.length > 1) {
      return sentences;
    }


    /*
      IDÉAL POUR VOUS

      On ne coupe PLUS sur "Votre" ou "Vos".
      Uniquement sur un nouveau "Vous".
    */

    if (mode === 'ideal') {
      var ideal = text
        .split(/\s+(?=(?:Vous|Si vous)\s)/)
        .map(clean)
        .filter(Boolean);

      if (ideal.length > 1) {
        return ideal;
      }
    }


    /*
      BÉNÉFICES
    */

    if (mode === 'benefits') {
      var benefits = text
        .split(
          /\s+(?=(?:Apaise|Aide|Nourrit|Hydrate|Protège|Soulage|Favorise|Réduit|Prévient|Préserve|Maintient|Soutient|Accompagne|Contribue|Améliore|Facilite|Renforce|Crée|Sans rinçage|Sans odeur|Sans goût|Sans couleur|Hypoallergénique|Compatible|Sécuritaire|Formule|100\s?%|Lanoline)\b)/
        )
        .map(clean)
        .filter(Boolean);

      if (benefits.length > 1) {
        return benefits;
      }
    }


    var loose = text
      .split(/\s*(?:;|\|)\s*/)
      .map(clean)
      .filter(Boolean);

    return loose.length > 1
      ? loose
      : [text];
  }


  function collect(source, mode) {
    if (!source) return [];

    var nodes =
      Array.from(
        source.querySelectorAll('li')
      );


    if (!nodes.length) {
      nodes =
        Array.from(source.children)
          .filter(function (node) {
            return [
              'P',
              'DIV',
              'BLOCKQUOTE'
            ].includes(node.tagName);
          });
    }


    var raw = nodes.length
      ? nodes
          .map(textWithBreaks)
          .filter(Boolean)
      : [textWithBreaks(source)]
          .filter(Boolean);


    var items = [];

    raw.forEach(function (chunk) {
      items = items.concat(
        splitChunk(chunk, mode)
      );
    });


    var seen = new Set();

    return items
      .map(function (item) {
        return clean(item)
          .replace(
            /^[✓✔•●▪]\s*/,
            ''
          );
      })
      .filter(function (item) {
        if (!item || item.length < 3) {
          return false;
        }

        var key =
          item.toLowerCase();

        if (seen.has(key)) {
          return false;
        }

        seen.add(key);

        return true;
      })
      .slice(0, 6);
  }


  /* =========================================================
     BÉNÉFICES
     ========================================================= */

  function renderBenefits(root) {
    var source =
      root.querySelector(
        '[data-bpm-benefits-source]'
      );

    var grid =
      root.querySelector(
        '[data-bpm-benefits-grid]'
      );

    if (!source || !grid) {
      return;
    }


    var items =
      collect(source, 'benefits');

    if (!items.length) {
      return;
    }


    grid.innerHTML = '';


    items.forEach(
      function (text, index) {

        var article =
          document.createElement(
            'article'
          );

        article.className =
          'bpm-benefit-item';


        var number =
          document.createElement(
            'span'
          );

        number.className =
          'bpm-benefit-item__number';

        number.textContent =
          String(index + 1)
            .padStart(2, '0');


        var title =
          document.createElement(
            'p'
          );

        title.className =
          'bpm-benefit-item__title';

        title.textContent = text;


        article.appendChild(number);
        article.appendChild(title);

        grid.appendChild(article);
      }
    );
  }


  /* =========================================================
     IDÉAL POUR VOUS
     ========================================================= */

  function renderIdeal(root) {
    var source =
      root.querySelector(
        '[data-bpm-ideal-source]'
      );

    var grid =
      root.querySelector(
        '[data-bpm-ideal-grid]'
      );

    if (!source || !grid) {
      return;
    }


    var items =
      collect(source, 'ideal');

    if (!items.length) {
      return;
    }


    grid.innerHTML = '';


    items.forEach(function (text) {

      var article =
        document.createElement(
          'article'
        );

      article.className =
        'bpm-ideal-item';


      var check =
        document.createElement(
          'span'
        );

      check.className =
        'bpm-ideal-item__check';

      check.setAttribute(
        'aria-hidden',
        'true'
      );

      check.textContent = '✓';


      var title =
        document.createElement(
          'p'
        );

      title.className =
        'bpm-ideal-item__title';

      title.textContent = text;


      article.appendChild(check);
      article.appendChild(title);

      grid.appendChild(article);
    });
  }


  /* =========================================================
     FAQ — LARGEUR CORRECTE
     ========================================================= */

  function forceFaqLayout() {

    document
      .querySelectorAll(
        '.bpm-product-tabs__panel--faq .bpm-full-faq'
      )
      .forEach(function (faq) {


        faq.style.setProperty(
          'display',
          'block',
          'important'
        );

        faq.style.setProperty(
          'grid-template-columns',
          'none',
          'important'
        );

        faq.style.setProperty(
          'grid-template-rows',
          'none',
          'important'
        );

        faq.style.setProperty(
          'width',
          '100%',
          'important'
        );

        faq.style.setProperty(
          'max-width',
          'none',
          'important'
        );

        faq.style.setProperty(
          'margin',
          '0',
          'important'
        );

        faq.style.setProperty(
          'padding',
          '0',
          'important'
        );


        var layout =
          faq.querySelector(
            '.bpm-faq-premium__layout'
          );


        if (layout) {
          layout.style.setProperty(
            'display',
            'grid',
            'important'
          );

          layout.style.setProperty(
            'grid-template-columns',
            'minmax(270px, .72fr) minmax(0, 1.28fr)',
            'important'
          );

          layout.style.setProperty(
            'gap',
            '70px',
            'important'
          );

          layout.style.setProperty(
            'align-items',
            'start',
            'important'
          );

          layout.style.setProperty(
            'width',
            '100%',
            'important'
          );

          layout.style.setProperty(
            'max-width',
            'none',
            'important'
          );
        }


        var content =
          faq.querySelector(
            '.bpm-faq-premium__content'
          );


        if (content) {
          content.style.setProperty(
            'display',
            'block',
            'important'
          );

          content.style.setProperty(
            'width',
            '100%',
            'important'
          );

          content.style.setProperty(
            'min-width',
            '0',
            'important'
          );

          content.style.setProperty(
            'max-width',
            'none',
            'important'
          );
        }


        var list =
          faq.querySelector(
            '.bpm-full-faq__list'
          );


        if (list) {
          list.style.setProperty(
            'display',
            'block',
            'important'
          );

          list.style.setProperty(
            'width',
            '100%',
            'important'
          );

          list.style.setProperty(
            'min-width',
            '0',
            'important'
          );

          list.style.setProperty(
            'max-width',
            'none',
            'important'
          );

          list.style.setProperty(
            'margin',
            '0',
            'important'
          );

          list.style.setProperty(
            'border-top',
            '1px solid #e5e5e2',
            'important'
          );
        }


        faq
          .querySelectorAll(
            '.bpm-full-faq__item'
          )
          .forEach(function (item) {

            item.style.setProperty(
              'display',
              'block',
              'important'
            );

            item.style.setProperty(
              'width',
              '100%',
              'important'
            );

            item.style.setProperty(
              'max-width',
              'none',
              'important'
            );
          });


        faq
          .querySelectorAll(
            '.bpm-full-faq__question'
          )
          .forEach(function (question) {

            question.style.setProperty(
              'display',
              'flex',
              'important'
            );

            question.style.setProperty(
              'align-items',
              'center',
              'important'
            );

            question.style.setProperty(
              'justify-content',
              'space-between',
              'important'
            );

            question.style.setProperty(
              'width',
              '100%',
              'important'
            );

            question.style.setProperty(
              'min-width',
              '0',
              'important'
            );

            question.style.setProperty(
              'max-width',
              'none',
              'important'
            );

            question.style.setProperty(
              'min-height',
              '64px',
              'important'
            );

            question.style.setProperty(
              'gap',
              '28px',
              'important'
            );

            question.style.setProperty(
              'white-space',
              'normal',
              'important'
            );

            question.style.setProperty(
              'word-break',
              'normal',
              'important'
            );
          });


        faq
          .querySelectorAll(
            '.bpm-full-faq__answer'
          )
          .forEach(function (answer) {

            answer.style.setProperty(
              'width',
              '100%',
              'important'
            );

            answer.style.setProperty(
              'max-width',
              'none',
              'important'
            );
          });

      });
  }


  /* =========================================================
     PRODUITS ASSOCIÉS
     IMPORTANT :
     nouvelle structure = MEDIA + CONTENT
     On ne supprime surtout plus CONTENT.
     ========================================================= */

  function fixAssociatedProducts() {

    document
      .querySelectorAll(
        '.bpm-associated-wide'
      )
      .forEach(function (section) {


        var grid =
          section.querySelector(
            '.bpm-associated-wide__grid'
          );

        if (!grid) {
          return;
        }


        /*
          La grille ne contient que
          les cartes produits.
        */

        Array
          .from(grid.children)
          .forEach(function (child) {

            if (
              !child.classList.contains(
                'bpm-associated-card'
              )
            ) {
              child.remove();
            }

          });


        section
          .querySelectorAll(
            '.bpm-associated-card'
          )
          .forEach(function (card) {


            /*
              Une carte contient uniquement :

              MEDIA
              CONTENT
            */

            Array
              .from(card.children)
              .forEach(function (child) {

                var allowed =
                  child.classList.contains(
                    'bpm-associated-card__media'
                  ) ||
                  child.classList.contains(
                    'bpm-associated-card__content'
                  );

                if (!allowed) {
                  child.remove();
                }

              });


            /* Carte */

            card.style.setProperty(
              'display',
              'flex',
              'important'
            );

            card.style.setProperty(
              'flex-direction',
              'column',
              'important'
            );

            card.style.setProperty(
              'visibility',
              'visible',
              'important'
            );

            card.style.setProperty(
              'opacity',
              '1',
              'important'
            );


            /* Contenu */

            var content =
              card.querySelector(
                '.bpm-associated-card__content'
              );

            if (content) {

              content.style.setProperty(
                'display',
                'flex',
                'important'
              );

              content.style.setProperty(
                'flex-direction',
                'column',
                'important'
              );

              content.style.setProperty(
                'flex',
                '1',
                'important'
              );

              content.style.setProperty(
                'visibility',
                'visible',
                'important'
              );

              content.style.setProperty(
                'opacity',
                '1',
                'important'
              );

            }


            /* Marque */

            var vendor =
              card.querySelector(
                '.bpm-associated-card__vendor'
              );

            if (vendor) {
              vendor.style.setProperty(
                'display',
                'block',
                'important'
              );
            }


            /* Titre */

            var title =
              card.querySelector(
                '.bpm-associated-card__title'
              );

            if (title) {
              title.style.setProperty(
                'visibility',
                'visible',
                'important'
              );

              title.style.setProperty(
                'opacity',
                '1',
                'important'
              );
            }


            /* Prix */

            var price =
              card.querySelector(
                '.bpm-associated-card__price'
              );

            if (price) {

              price.style.setProperty(
                'display',
                'flex',
                'important'
              );

              price.style.setProperty(
                'visibility',
                'visible',
                'important'
              );

              price.style.setProperty(
                'opacity',
                '1',
                'important'
              );

            }


            /* Action */

            var action =
              card.querySelector(
                '.bpm-associated-card__action'
              );

            if (action) {

              action.style.setProperty(
                'display',
                'block',
                'important'
              );

              action.style.setProperty(
                'width',
                '100%',
                'important'
              );

              action.style.setProperty(
                'visibility',
                'visible',
                'important'
              );

              action.style.setProperty(
                'opacity',
                '1',
                'important'
              );

            }


            /* Formulaire */

            var form =
              card.querySelector(
                '.bpm-associated-card__form'
              );

            if (form) {

              form.style.setProperty(
                'display',
                'block',
                'important'
              );

              form.style.setProperty(
                'width',
                '100%',
                'important'
              );

              form.style.setProperty(
                'visibility',
                'visible',
                'important'
              );

              form.style.setProperty(
                'opacity',
                '1',
                'important'
              );

            }


            /* Bouton */

            var button =
              card.querySelector(
                '.bpm-associated-card__button'
              );

            if (button) {

              button.style.setProperty(
                'display',
                'flex',
                'important'
              );

              button.style.setProperty(
                'align-items',
                'center',
                'important'
              );

              button.style.setProperty(
                'justify-content',
                'center',
                'important'
              );

              button.style.setProperty(
                'width',
                '100%',
                'important'
              );

              button.style.setProperty(
                'visibility',
                'visible',
                'important'
              );

              button.style.setProperty(
                'opacity',
                '1',
                'important'
              );

            }


            /*
              On supprime seulement
              d'éventuels moyens de paiement
              DANS la carte.
            */

            card
              .querySelectorAll(
                '.shopify-payment-button,' +
                '.shopify-payment-terms,' +
                '.list-payment,' +
                '[data-shopify-payment-button],' +
                '[class*="payment-icon"],' +
                '[class*="payment-method"],' +
                '[class*="payment-icons"],' +
                '[class*="payment-list"]'
              )
              .forEach(function (node) {
                node.remove();
              });

          });

      });
  }


  /* =========================================================
     RESPONSIVE FAQ
     ========================================================= */

  function fixResponsiveFaq() {

    if (window.innerWidth > 989) {
      return;
    }


    document
      .querySelectorAll(
        '.bpm-product-tabs__panel--faq .bpm-faq-premium__layout'
      )
      .forEach(function (layout) {

        layout.style.setProperty(
          'grid-template-columns',
          '1fr',
          'important'
        );

        layout.style.setProperty(
          'gap',
          '24px',
          'important'
        );

      });
  }


  /* =========================================================
     RUN
     ========================================================= */

  function run(scope) {

    var container =
      scope || document;


    container
      .querySelectorAll(
        '[data-bpm-benefits]'
      )
      .forEach(renderBenefits);


    container
      .querySelectorAll(
        '[data-bpm-ideal]'
      )
      .forEach(renderIdeal);


    forceFaqLayout();

    fixResponsiveFaq();

    fixAssociatedProducts();
  }


  function runDelayed() {

    run(document);

    setTimeout(
      function () {
        run(document);
      },
      100
    );

    setTimeout(
      function () {
        run(document);
      },
      500
    );

    setTimeout(
      function () {
        run(document);
      },
      1200
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      runDelayed
    );

  } else {

    runDelayed();

  }


  /* =========================================================
     CLIC ONGLETS
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var clickedTab =
        event.target.closest(
          '[data-bpm-tab]'
        );

      if (!clickedTab) {
        return;
      }


      setTimeout(
        function () {
          forceFaqLayout();
          fixResponsiveFaq();
          fixAssociatedProducts();
        },
        0
      );


      setTimeout(
        function () {
          forceFaqLayout();
          fixAssociatedProducts();
        },
        150
      );

    }
  );


  /* =========================================================
     SHOPIFY EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      setTimeout(
        function () {
          run(
            event.target ||
            document
          );
        },
        0
      );

    }
  );


  /* =========================================================
     RESIZE
     ========================================================= */

  window.addEventListener(
    'resize',
    function () {

      setTimeout(
        function () {
          forceFaqLayout();
          fixResponsiveFaq();
        },
        100
      );

    }
  );


  /* =========================================================
     OBSERVER
     uniquement ajout/suppression d'éléments.
     Pas les changements de style.
     ========================================================= */

  if (document.body) {

    var observer =
      new MutationObserver(
        function (mutations) {

          var hasNewNodes =
            mutations.some(
              function (mutation) {
                return (
                  mutation.addedNodes &&
                  mutation.addedNodes.length
                );
              }
            );


          if (!hasNewNodes) {
            return;
          }


          setTimeout(
            function () {
              fixAssociatedProducts();
              forceFaqLayout();
            },
            0
          );

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }

})();